import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Spinner from '../Utility/Spinner/Spinner';

import { Wrapper } from './styles';

export default class Placeholder extends Component {
  static propTypes = {
    background: PropTypes.oneOf(['none', 'dashboard'])
  };

  static defaultProps = {
    background: 'none'
  };

  render() {
    const { background } = this.props;

    return (
      <Wrapper background={background}>
        <Spinner />
      </Wrapper>
    );
  }
}
